import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import 'core-js';
import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { Provider } from 'react-redux';
import store from './store/';

// Silence the benign "ResizeObserver loop" warnings (fired by react-select and other
// libraries while they resize) so they don't trigger the dev-server error overlay.
// They are harmless and never appear in production.
window.addEventListener('error', e => {
    if (e.message && e.message.includes('ResizeObserver loop')) {
        e.stopImmediatePropagation();
        const overlay = document.getElementById(
            'webpack-dev-server-client-overlay',
        );
        if (overlay) overlay.style.display = 'none';
    }
});

// React 17 app: ReactDOM.render is correct here (createRoot is React 18+).
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
